<div class="hidden w-full p-8 border rounded-md shadow-xs sm:block mt-9">
	<div class="sm:flex sm:justify-between sm:items-center">
		<div class="flex pr-4">
			<div class="flex-shrink-0 mr-6">
				<img
					class="rounded-md"
					width="64"
					height="64"
					[ngSrc]="'/assets/img/hi-1.png' | cdn"
					alt=""
				/>
			</div>
			<div class="mt-1">
				<h4 class="text-xl font-bold text-gray-700">
					{{ categoryTitle() }}
				</h4>
				<p class="mt-0 text-gray-500">
					{{ description() }}
				</p>
			</div>
		</div>
		<a
			[routerLink]="['/guides', categoryUrl()]"
			class="inline-flex items-center justify-center w-full transition-colors blue-button sm:w-auto focus:outline-none"
		>
			View Guides
			<uc-arrow-long-right-svg />
		</a>
	</div>
</div>
